import {
  Card,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid
} from '@mui/material'
import { Loading, useTranslate } from 'react-admin'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { groupBy, isEmpty, isNil, keys, map, split } from 'lodash/fp'
import { useGetAnnounces } from 'components/DataProvider'
import { type AnnounceItem } from '../../../../cdk/bapp/lib/lambda-api/src/types'
import { format, parseISO } from 'date-fns/fp'
import log from 'loglevel'
import { type ReactElement } from 'react'

log.setLevel(log.levels.DEBUG)

const env = process.env['ENV'] as string
const urlBase = `https://${
  {
    prd: 'sapp.terashite.jp',
    stg: 'sapp-stg.terashite.jp',
    int: 'sapp-int.dev.terashite.jp',
    dev: 'sapp.dev.terashite.jp',
    exp: 'sapp-exp.dev.terashite.jp'
  }[env] as string
}/files`

export const drawAnnounces = (data: AnnounceItem[]): ReactElement[] => {
  const dataByDate = groupBy<AnnounceItem>('date')(data)
  return map((date: string) => {
    // @ts-expect-error ts(2339)
    return map.convert({ cap: false })((item: AnnounceItem, index: number) => {
      const { content, file, partner } = item
      return (
        <Grid container sx={{ ml: '2em' }} key={index}>
          <Grid item xs={2}>
            {index === 0 ? (
              <Typography variant="body1">
                {format('yyyy年M月d日')(parseISO(date))}
              </Typography>
            ) : null}
          </Grid>
          <Grid item xs={10}>
            <>
              {
                // @ts-expect-error ts(2339)
                map.convert({ cap: false })((line: string, index: number) =>
                  isEmpty(line) ? (
                    <br key={index} />
                  ) : (
                    <Typography variant="body2" key={index}>
                      {line}
                    </Typography>
                  )
                )(split('\n')(content))
              }
              {!isNil(file) && !isEmpty(file) && (
                <div key={`url-${index}`}>
                  <a
                    href={`${urlBase}${
                      isNil(partner) ? '/' : '/' + partner + '/'
                    }${file}`}
                    target="_blank">
                    ダウンロード
                  </a>
                </div>
              )}
            </>
          </Grid>
        </Grid>
      )
    })(dataByDate[date])
  })(keys(dataByDate))
}

export const Announce: React.FC<{ partner: string }> = ({ partner }) => {
  const translate = useTranslate()
  const { isLoading, data } = useGetAnnounces(partner)
  if (isLoading as boolean) return <Loading />
  if (isEmpty(data)) return null
  return (
    <Card raised sx={{ width: '1280px', marginTop: '1em' }}>
      <Accordion defaultExpanded={!isEmpty(data)}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="body1">
            {translate('resources.announce.title')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>{drawAnnounces(data)}</AccordionDetails>
      </Accordion>
    </Card>
  )
}
